<section
  class="o-layout__item c-card c-hero"
  [ngClass]="{ 'c-hero--danger': !hasManagerAccess }"
>
  <div class="c-card__content u-border-0">
    <div class="o-layout__item c-hero__left u-margin-0">
      <div class="u-layout-auto">
        <h1>
          <span *ngIf="account.type === accountType.SUBSCRIBED">{{
            account.getPackageSize() | lsTranslate
          }}</span>

          <span
            *ngIf="account.type === accountType.FREEACCOUNT"
            i18n="Account|Trial @@accountTrial"
            >Trial</span
          >

          <span
            *ngIf="
              account.type !== accountType.SUBSCRIBED &&
              account?.type !== accountType.FREEACCOUNT
            "
            class="capitalize"
            >{{ account.type }}</span
          >
        </h1>

        <h6>
          <span
            *ngIf="account.type === accountType.INTERNAL"
            i18n="Account|developer plan @@developerPlan"
            class="strong"
            >is the developer plan</span
          >

          <span
            *ngIf="
              account.type === accountType.FREEACCOUNT &&
              account?.expirationDate.isAfter(now)
            "
            i18n="Account|days left @@accountDaysLeft"
            class="strong"
            >you have {{ account.expirationDate.diff(now, 'days') }} days
            left</span
          >

          <span
            *ngIf="
              account.type === accountType.FREEACCOUNT &&
              account?.expirationDate.isBefore(now)
            "
            i18n="Account|expired account @@accountExpired"
            class="strong"
            >your account is expired</span
          >

          <ng-container
            *ngIf="
              account.type === accountType.BLOCKED ||
              account?.type === accountType.SUSPENDED
            "
          >
            <button
              type="submit"
              #payNow
              class="o-button o-button--danger o-button--small c-loader-button"
              (click)="requestPaymentUrl()"
            >
              Pay Now
            </button>
          </ng-container>
        </h6>
        <br />
        <span class="white" i18n="Account|having issues @@accountHavingIssues"
          >Having Issues?
        </span>
        <a
          href="mailto:sales@lightspeedhq.com"
          title="sales@lightspeedhq.com"
          class="white underline"
          i18n="Account|Contact sales @@contactSales"
        >
          Contact Sales
        </a>
      </div>
    </div>
    <div
      class="o-layout__item c-hero__right u-margin-0 u-border-0 u-layout-grow"
    >
      <h6
        i18n="Account|title for current subscription @@currentSubscriptionTitle"
      >
        Your current package includes:
      </h6>
      <div class="c-hero__box">
        <ng-container *ngIf="account.type === accountType.FREEACCOUNT">
          <h1 id="devicenumber">∞</h1>
        </ng-container>
        <ng-container *ngIf="account.type !== accountType.FREEACCOUNT">
          <h1 id="devicenumber">{{ account.allowedNumberOfDevices }}</h1>
        </ng-container>

        <h6 class="u-color-gray">
          <i class="fa fa-tablet" aria-hidden="true"></i>
          <span i18n="Account|title for devices @@devicesTitle">Devices</span>
        </h6>
      </div>
      <div class="c-hero__box">
        <h1>1</h1>
        <h6 class="u-color-gray">
          <i class="fa fa-building-o" aria-hidden="true"></i>
          <span i18n="Account|title for Business @@dbusinessTitle"
            >Business</span
          >
        </h6>
      </div>
      <div class="c-hero__box">
        <h1>∞</h1>
        <h6 class="u-color-gray">
          <i class="fa fa-print" aria-hidden="true"></i>
          <span i18n="Account|title for printers @@printersTitle"
            >Printers</span
          >
        </h6>
      </div>
    </div>
  </div>
</section>
